/* JUSTPRESS text editor typefaces. Written by p250/jpfonts.py from p250/fonts.json (the licence of each font is recorded
   there); the theme ships it as assets/jp-fonts.js, PROTO-2 inlines it. Do not edit by hand.
   JPFonts.list: [group, id, label, CSS family stack, weight, smallest capital height in mm before the editor flags it].
   The stylesheet (one <link data-jp-fonts>) only declares the faces: a font file downloads when text is drawn in it.
   JPFonts.id(x): the font id for a saved id (old aliases too), JPFonts.load(id, text) -> Promise(true once the face is really
   there), JPFonts.changed(fn): fn after fonts arrive. */
(function (w) {
  if (w.JPFonts) return;
  var CSS = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500&family=Playfair+Display&family=Lora:wght@500&family=EB+Garamond:wght@500&family=Libre+Baskerville&family=Jost:wght@400;500&family=Josefin+Sans:wght@300&family=Montserrat:wght@500&family=Raleway:wght@500&family=Quicksand:wght@500&family=Pinyon+Script&family=Great+Vibes&family=Allura&family=Parisienne&family=Dancing+Script:wght@500&family=Caveat:wght@500&family=Kalam&family=Patrick+Hand&family=Gochi+Hand&family=Homemade+Apple&family=Amatic+SC:wght@700&family=Special+Elite&family=Courier+Prime&family=Cutive+Mono&family=Space+Mono&family=Pirata+One&family=Cinzel:wght@500&family=Abril+Fatface&family=Bebas+Neue&family=Lobster&display=swap";
  var G = [["serif", "Serif"], ["sans", "Sans"], ["script", "Script"], ["hand", "Handwritten"], ["type", "Typewriter"], ["display", "Display"]];
  var L = [
    ["serif", "cormorant", "Cormorant", "\"Cormorant Garamond\",Georgia,serif", "500", 4.6],
    ["serif", "playfair", "Playfair", "\"Playfair Display\",Georgia,serif", "400", 4.6],
    ["serif", "lora", "Lora", "Lora,Georgia,serif", "500", 4.6],
    ["serif", "garamond", "EB Garamond", "\"EB Garamond\",Georgia,serif", "500", 4.6],
    ["serif", "baskerville", "Baskerville", "\"Libre Baskerville\",Georgia,serif", "400", 4.6],
    ["sans", "jost", "Jost", "Jost,Helvetica,Arial,sans-serif", "500", 4.6],
    ["sans", "josefin", "Josefin Light", "\"Josefin Sans\",Helvetica,Arial,sans-serif", "300", 4.6],
    ["sans", "montserrat", "Montserrat", "Montserrat,Helvetica,Arial,sans-serif", "500", 4.6],
    ["sans", "raleway", "Raleway", "Raleway,Helvetica,Arial,sans-serif", "500", 4.6],
    ["sans", "quicksand", "Quicksand", "Quicksand,Helvetica,Arial,sans-serif", "500", 4.6],
    ["script", "pinyon", "Pinyon", "\"Pinyon Script\",cursive", "400", 7.6],
    ["script", "vibes", "Great Vibes", "\"Great Vibes\",cursive", "400", 7.6],
    ["script", "allura", "Allura", "Allura,cursive", "400", 7.6],
    ["script", "parisienne", "Parisienne", "Parisienne,cursive", "400", 7.6],
    ["script", "dancing", "Dancing Script", "\"Dancing Script\",cursive", "500", 6.4],
    ["hand", "caveat", "Caveat", "Caveat,cursive", "500", 6.4],
    ["hand", "kalam", "Kalam", "Kalam,cursive", "400", 6.4],
    ["hand", "patrick", "Patrick Hand", "\"Patrick Hand\",cursive", "400", 6.4],
    ["hand", "gochi", "Gochi Hand", "\"Gochi Hand\",cursive", "400", 6.4],
    ["hand", "apple", "Homemade Apple", "\"Homemade Apple\",cursive", "400", 6.4],
    ["hand", "amatic", "Amatic", "\"Amatic SC\",cursive", "700", 6.4],
    ["type", "special", "Special Elite", "\"Special Elite\",monospace", "400", 4.6],
    ["type", "courier", "Courier Prime", "\"Courier Prime\",monospace", "400", 4.6],
    ["type", "cutive", "Cutive Mono", "\"Cutive Mono\",monospace", "400", 4.6],
    ["type", "spacemono", "Space Mono", "\"Space Mono\",monospace", "400", 4.6],
    ["display", "pirata", "Blackletter", "\"Pirata One\",serif", "400", 7.6],
    ["display", "cinzel", "Cinzel", "Cinzel,Georgia,serif", "500", 4.6],
    ["display", "abril", "Abril Fatface", "\"Abril Fatface\",Georgia,serif", "400", 5.5],
    ["display", "bebas", "Bebas Neue", "\"Bebas Neue\",Impact,sans-serif", "400", 4.6],
    ["display", "lobster", "Lobster", "Lobster,cursive", "400", 6.4]];
  var A = {"elite": "special"};
  var by = {}; L.forEach(function (f) { by[f[1]] = f; });
  function id(x) { x = String(x || '').toLowerCase(); return A[x] || x; }
  var sheet = null;
  function css() {
    if (sheet) return sheet;
    sheet = new Promise(function (res) {
      var d = w.document, el = d.querySelector('link[data-jp-fonts]'), n = 0;
      if (!el) { el = d.createElement('link'); el.rel = 'stylesheet'; el.href = CSS; el.setAttribute('data-jp-fonts', ''); d.head.appendChild(el); }
      (function wait() { if (el.sheet) { if (el.media && el.media !== 'all') el.media = 'all'; return res(true); } if (++n > 80) return res(false); setTimeout(wait, 125); })();
    });
    return sheet;
  }
  /* the face is there when text in it is not as wide as in the fallbacks alone */
  function has(f) {
    try {
      var c = w.document.createElement('canvas').getContext('2d'), t = 'Hamburgefonstiv 0123 Mia', fam = f[3].split(',')[0], same = 0;
      ['monospace', 'serif'].forEach(function (g) { c.font = f[4] + ' 72px ' + g; var a = c.measureText(t).width; c.font = f[4] + ' 72px ' + fam + ',' + g; if (Math.abs(c.measureText(t).width - a) < 0.5) same++; });
      return same < 2;
    } catch (e) { return true; }
  }
  function load(k, text) {
    var f = by[id(k)]; if (!f) return Promise.resolve(false);
    return css().then(function () { var fs = w.document.fonts; return fs && fs.load ? fs.load(f[4] + ' 40px ' + f[3], text || f[2]).catch(function () {}) : null; })
      .then(function () { return has(f); });
  }
  function changed(fn) {
    var t = 0, go = function () { clearTimeout(t); t = setTimeout(fn, 80); }, fs = w.document.fonts;
    if (fs && fs.addEventListener) fs.addEventListener('loadingdone', go);
    css().then(go);
  }
  w.JPFonts = { css: CSS, groups: G, list: L, byId: by, id: id, load: load, has: has, changed: changed };
})(window);
